import styles from "./AbtestSaleTip.module.scss";

function SaleTip(props: {
  text: string
}) {
  const { text } = props;
  return (
    <>
      {
        <div className={styles.text}>
          {text}
        </div>
      }
    </>
  )
}

export default SaleTip
